import { CheckCircle2, Play } from "lucide-react";
import { useEffect, useState } from "react";
import { deviceConfig, getStoredToken } from "../lib/deviceApi";

// Paired-TV home. Shown when the viewer presses Exit (X) in the player. Holds ONLY the
// scoped wwd_ device token — never a Supabase session, no account/admin functionality.
// Validates the token on entry; a revoked/expired token falls back to the pairing flow.
export function TvHome({ onResume, onUnlinked }) {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    (async () => {
      const token = getStoredToken();
      if (!token) { onUnlinked(); return; }
      const r = await deviceConfig(token);
      if (r.status === 403) { onUnlinked("This TV was unlinked from your account. Link it again to continue."); return; }
      if (r.status === 401) { onUnlinked("This TV's session expired. Link it again to continue."); return; }
      // ok or transient/network — remain on the home screen.
      setChecking(false);
    })();
  }, [onUnlinked]);

  if (checking) {
    return (
      <div className="tv-root tv-brandbg tv-center" data-testid="tv-home-checking">
        <div className="tv-spinner-text">World Wide Wallpaper</div>
      </div>
    );
  }

  return (
    <div className="tv-root tv-brandbg tv-center" data-testid="tv-home">
      <div className="tv-state-card">
        <div className="tv-brand" style={{ justifyContent: "center" }}>
          <img className="tv-emblem" src="/brand/www-emblem.png" alt=""
               onError={(e) => { e.currentTarget.style.display = "none"; }} />
          <span className="tv-wordmark">World Wide Wallpaper</span>
        </div>
        <div data-testid="tv-home-linked"
             style={{ display: "inline-flex", alignItems: "center", gap: 8, color: "#2f8f5b",
                      fontWeight: 600, fontSize: 16, marginBottom: 14 }}>
          <CheckCircle2 size={20} /> This TV is linked to your account
        </div>
        <h2>Ready when you are</h2>
        <p>Press resume to return to your calm, ever-changing slideshow of photographs from around the world.</p>
        <button className="tv-btn" data-testid="tv-home-resume" autoFocus onClick={onResume}
                style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <Play size={18} /> Resume viewing
        </button>
        <p className="muted" data-testid="tv-home-guidance"
           style={{ fontSize: 14, marginTop: 22, color: "var(--tv-charcoal-soft)" }}>
          Use your phone to change filters or manage this TV — the slideshow updates automatically.
        </p>
      </div>
    </div>
  );
}
